// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"173fc722","239":"249c571e","453":"e5515c25","667":"18b40292"}[chunkId] + ".chunk.js";
};